import React, { useState, useEffect } from 'react';
import './BackToTop.css';
import { FiArrowUp } from 'react-icons/fi';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Smooth scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility, { passive: true });
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div className="back-to-top">
      {isVisible && (
        <button
          type="button"
          onClick={scrollToTop}
          className="back-to-top-button"
          aria-label="Back to top"
          title="Back to top"
        >
          <FiArrowUp size={24} />
        </button>
      )}
    </div>
  );
};

export default BackToTop;
